import { configureStore } from '@reduxjs/toolkit'
import appSlice from "./App/AppSlice";
import createNewSlice from "./Pages/CreateNew/CreateNewSlice";

export const store = configureStore({
    reducer: {
        counter: appSlice,
        createNew: createNewSlice
    },
    middleware: getDefaultMiddleware => getDefaultMiddleware()
})

export type RootState = ReturnType<typeof store.getState>
export type AppDispatch = typeof store.dispatch